import Add16 from '@carbon/icons-react/es/add/16';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from 'components/atoms/button';

export const AddButton = () => (
  <Button type="link" size="small" icon={<Add16 />}>
    <FormattedMessage id="attachment.add" />
  </Button>
);
